<template>
  <div>
    <template v-for="promiseConf in promiseConfList">
      <div :key="promiseConf.shopId" class="set-promise">
        <el-image :src="promiseConf.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
        <el-tooltip v-if="promiseConf.channelIcon" :content="promiseConf.channelName" style="margin: 0px -6px 0px 6px;">
            <el-image :src="promiseConf.channelIcon" style="width: 18px; height: 18px;"></el-image>
        </el-tooltip>
        <span class="shop-title">{{ promiseConf.shopName }} <span v-if="promiseConf.requiredFlag" class="danger-text">*</span></span>
        <el-select v-model="values[promiseConf.shopId]" placeholder="请选择发货时效模板" clearable :value-key="String(promiseConf.shopId)" @change="selectChange">
          <el-option
            v-for="item in promiseConf.promiseTemplateDtoList"
            :key="item.templateId"
            :label="item.templateName"
            :value="item.templateId"
          >
          </el-option>
        </el-select>
        <el-link style="margin-left: 8px" href="https://trade-delivery-jdm.jd.com/promiseTimeliness/PromiseTemplate" target="_blank"
          >设置发货时效模板</el-link
        >
        <el-link v-if="values[promiseConf.shopId] && promiseConfList.length>1" style="margin-left: 8px" @click="handleSetToShop(promiseConf,values[promiseConf.shopId])"
          >应用到其他店铺</el-link
        >
      </div>
    </template>
    <el-dialog-select-shop
      :visible.sync="shopDialogVisible"
      :shopData="shopList"
      :selected="selectShopIds"
      placeholder="店铺名称"
      @confirm="confirmSelectShop"
  ></el-dialog-select-shop>
  </div>
</template>

<script>
import _ from 'lodash';
import { getShopList } from '@servers/base/shop/index.js';
export default {
  name: 'PromiseConfig',
  props: {
    promiseConfList: {
      type: Array,
      default() {
        return [];
      },
    },
    values: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  created() {
    // 获取所有店铺信息
    this.getShopList();
  },
  data() {
    return {
      shopDialogVisible:false,
      selectShopIds: '',
      shopList:[],
      applyShopName:'',//发货时效应用的店铺名称
      applyShopObj:[],//发货时效应用的店铺对象
    };
  },
  methods: {
    selectChange(v) {
      this.$emit('change');
    },
    async getShopList() {
      const res = await getShopList({
          source: 'jd',
          pageNo: 1,
          pageSize: 500
      });
      this.shopList = res.list || [];
    },
    handleSetToShop(promiseConf,applyShopName){
      this.applyShopObj = promiseConf
      const shopObj = promiseConf.promiseTemplateDtoList.find(item=>item.templateId == applyShopName)
      this.shopDialogVisible = true;
      this.applyShopName = shopObj.templateName
    },
    confirmSelectShop(shops){
      this.shopDialogVisible = false
      this.$confirm(`选中店铺将匹配发货时效【${this.applyShopName}】，匹配后将覆盖原发货时效，未匹配到将跳过，是否确认`, '提示', {
          confirmButtonText: '确定',
          type: 'warning'
      }).then(() => {
        this.promiseConfList.map((item)=>{
          if(this.applyShopObj.shopId === item.shopId) return item
           const findIndex = shops.findIndex(shopItem=> shopItem.id == item.shopId)
           const valueFindObj = item.promiseTemplateDtoList.find(promiseItem=> promiseItem.templateName == this.applyShopName )
           if(findIndex !=-1 && valueFindObj?.templateName){
             this.$set(this.values,String(item.shopId),valueFindObj.templateId)
           }
           return item
        })
        this.$message.success('更新发货时效成功！')
      }).catch(() => {
        // this.$message.error('更新发货时效失败！')
      });

    },
  },
};
</script>

<style lang="scss" scoped>
.set-promise {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.danger-text {
  color: red;
}
</style>